import React from "react"
import loadable from "@loadable/component"

import Top from "./Top"

const LogoAndText = loadable(() => import("./LogoAndText"))

export default function CallToAction() {
  return (
    <>
      <LogoAndText />
      <Top />
    </>
  )
}
